/**
 * Regras de duração da presença (fonte de verdade no servidor:
 * `venue_presence_window_end`, `confirm_still_here`, `notify_still_here_due`).
 * Estes valores só orientam quando o app mostra o aviso "Ainda está aqui?".
 */
export const PRESENCE_MAX_DURATION_MS = 3 * 60 * 60 * 1000;
export const STILL_HERE_PROMPT_AFTER_MS = 90 * 60 * 1000;

export interface StillHerePromptRow {
  checkin_id: string;
  venue_id: string;
  venue_name: string | null;
  due_at: string;
  expires_at: string;
}

/** O aviso aparece a partir do horário indicado pelo servidor e enquanto a presença não venceu. */
export function isStillHereDue(row: Pick<StillHerePromptRow, "due_at" | "expires_at"> | null, nowMs: number): boolean {
  if (!row) return false;
  const due = Date.parse(row.due_at);
  const expires = Date.parse(row.expires_at);
  if (!Number.isFinite(due) || !Number.isFinite(expires)) return false;
  return nowMs >= due && nowMs < expires;
}

/** Fim da presença: 3 horas após a confirmação, ou o fechamento do local se vier antes. */
export function presenceWindowEnd(confirmedAtMs: number, closingAtMs: number | null): number {
  const max = confirmedAtMs + PRESENCE_MAX_DURATION_MS;
  if (closingAtMs === null || !Number.isFinite(closingAtMs) || closingAtMs <= confirmedAtMs) return max;
  return Math.min(max, closingAtMs);
}
